import { useAdmin } from '../hooks/useAdmin';
import { AdminToggle, AdminSecretModal } from './AdminControls';

export default function Footer() {
  const admin = useAdmin();

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div>
          Website by <strong>Cozy Software</strong>
          {' · '}
          <a href="mailto:morrisbmaina@gmail.com">morrisbmaina@gmail.com</a>
          {' · '}
          <a href="tel:+254743091839">+254 743 091 839</a>
          <br />
          <span style={{ opacity: 0.7 }}>&copy; {new Date().getFullYear()} All rights reserved.</span>
        </div>
        <AdminToggle adminMode={admin.adminMode} onToggle={admin.handleToggle} />
      </div>

      <AdminSecretModal
        open={admin.secretPrompt}
        email={admin.email}
        setEmail={admin.setEmail}
        password={admin.password}
        setPassword={admin.setPassword}
        error={admin.error}
        loading={admin.loading}
        onSubmit={admin.submitSecret}
        onCancel={admin.cancelAdmin}
      />
    </footer>
  );
}
